export default {
	computed: {
		$currentGame () {
			return this.$store.getters['user/getCurrentGame']
		}
	}
}
